"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'currency.error.missingCurrencyCode': 'El código de moneda es requerido',
    'currency.error.failedToGetRate': 'Error al obtener la tasa de cambio',
    'currency.error.missingConversionParams': 'La moneda de origen, moneda de destino y cantidad son requeridas',
    'currency.error.invalidAmount': 'La cantidad debe ser un número positivo',
    'currency.error.failedToConvert': 'Error al convertir la moneda',
    'currency.error.failedToGetCurrencies': 'Error al obtener la lista de monedas',
    'currency.error.failedToGetSupportedCurrencies': 'Error al obtener las monedas soportadas',
    'currency.error.missingHistoricalParams': 'El código de moneda, fecha de inicio y fecha de fin son requeridos',
    'currency.error.invalidDateFormat': 'El formato de fecha debe ser YYYY-MM-DD',
    'currency.error.failedToGetHistoricalRates': 'Error al obtener las tasas históricas',
    'currency.error.failedToGetGoldPrice': 'Error al obtener el precio del oro',
};
